import {createRouter, createWebHistory} from "vue-router";
import HomeView from "@/views/HomeView";
import OneOfficeView from "@/views/OneOfficeView.vue";
import OneDoctorView from "@/views/OneDoctorView.vue";
import TeamView from "@/views/TeamView.vue";
import ServicesView from "@/views/ServicesView.vue";
import OneCategoryView from "@/views/OneCategoryView.vue";
import OneServiceView from "@/views/OneServiceView.vue";
import NewsView from "@/views/NewsView.vue";
import OneNewsView from "@/views/OneNewsView.vue";
import ContactsView from "@/views/ContactsView.vue";
import BookAppointmentView from "@/views/BookAppointmentView.vue";
import AboutUsView from "@/views/AboutUsView.vue";
import VenousCenterView from "@/views/VenousCenterView.vue";
import {i18n} from '@/i18n'
import FullCareView from "@/views/FullCareView.vue";

const routes = [
    {
        path: encodeURI("/"),
        name: "home",
        component: HomeView,
    },
    {
        path: encodeURI("/кабинети/:id"),
        name: "OneOfficeView",
        component: OneOfficeView,
        meta: {title: i18n.global.t('meta-title-offices')}
    },
    {
        path: encodeURI("/специалисти/:id"),
        name: "OneDoctorView",
        component: OneDoctorView,
        meta: {title: i18n.global.t('meta-title-doctors')}
    },
    {
        path: encodeURI("/екип/"),
        name: "TeamView",
        component: TeamView,
        meta: {title: i18n.global.t('meta-title-team')}
    },
    {
        path: encodeURI("/услуги/"),
        name: "ServicesView",
        component: ServicesView,
        meta: {title: i18n.global.t('meta-title-services')}
    },
    {
        path: encodeURI("/категории/:id"),
        name: "OneCategoryView",
        component: OneCategoryView,
        meta: {title: i18n.global.t('meta-title-categories')}
    },
    {
        path: encodeURI("/услсуги/:id"),
        name: "OneServiceView",
        component: OneServiceView,
        meta: {title: i18n.global.t('meta-title-services')}
    },
    {
        path: encodeURI("/новини/"),
        name: "NewsView",
        component: NewsView,
        meta: {title: i18n.global.t('meta-title-news')}
    },
    {
        path: encodeURI("/новини/:id"),
        name: "OneNewsView",
        component: OneNewsView,
        meta: {title: i18n.global.t('meta-title-news')}
    },
    {
        path: encodeURI("/контакти/"),
        name: "ContactsView",
        component: ContactsView,
        meta: {title: i18n.global.t('meta-title-contacts')}
    },
    {
        path: encodeURI("/запази-час/"),
        name: "BookAppointmentView",
        component: BookAppointmentView,
        meta: {title: i18n.global.t('meta-title-book-appointment')}
    },
    {
        path: encodeURI("/за-нас/"),
        name: "AboutUsView",
        component: AboutUsView,
        meta: {title: i18n.global.t('meta-title-about')}
    },
    {
        path: encodeURI("/венозен-център/"),
        name: "VenousCenterView",
        component: VenousCenterView,
        meta: {title: i18n.global.t('meta-title-venous-center')}
    },
    {
        path: encodeURI("/пълна-грижа-за-вашето-здраве/"),
        name: "FullCareView",
        component: FullCareView,
        meta: {title: i18n.global.t('meta-title-full-care')}
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
